import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translationsRu } from './locale/ru/translation';
import { translationsAm } from './locale/am/translation';
import { translationsEn } from './locale/en/translation';

i18n.use(initReactI18next).init({
    fallbackLng: 'am',
    debug: process.env.NODE_ENV === 'development',
    resources: {
        en: { translation: translationsEn },
        am: { translation: translationsAm },
        ru: { translation: translationsRu },
    },
    lng: localStorage.getItem('i18nextLng') || 'am',
    interpolation: {
        escapeValue: false,
    },
});

// Keep <html lang> in sync with the active UI language. index.html hardcodes
// lang='en' while the default content is Armenian, which makes mobile browsers
// (Chrome/Samsung Internet on Android) treat the page as mistranslated and
// auto-translate it into a broken Armenian/Russian mix. Declaring the real
// content language stops that.
const syncHtmlLang = (lng: string) => {
    document.documentElement.lang = lng;
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;